export const MAX_INLINE_OPTIONS = 12;
export const LONG_OPTION_LENGTH = 20;
